import { imageStore } from '../images.js';
import Boundary from './Boundary.js';
import Sprite from '../ui/Sprite.js';

export default class WaterZone extends Boundary {
    serialize() {
        console.log(`Serializing ${this.constructor.name}`);
        return {
            position: this.position,
            visible: this.visible,
            encounterRate: this.encounterRate,
            data: this.data, // The tile ID for water sprite
        };
    }

    static deserialize(data) {
        return new WaterZone({
            position: data.position,
            visible: data.visible,
            encounterRate: data.encounterRate,
            data: data.data,
        });
    }

    constructor({ position, visible = true, encounterRate = 0.0, data }) {
        super({ position });
        this.encounterRate = encounterRate;
        this.visible = visible;
        this.data = data;
        const tileIdMap = {
            23770: 'img/seashore_northwest.png',
            23771: 'img/seashore_north.png',
            23772: 'img/seashore_northeast.png',
            23773: 'img/ocean_rock_top_left.png',
            23774: 'img/ocean_rock_top_right.png',
            23775: 'img/seashore_west.png',
            23776: 'img/sand.png',
            23777: 'img/seashore_east.png',
            23778: 'img/ocean_rock_bottom_left.png',
            23779: 'img/ocean_rock_bottom_right.png',
            23780: 'img/seashore_southwest.png',
            23781: 'img/seashore_south.png',
            23782: 'img/seashore_southeast.png',
            23783: 'img/ocean_rock_top_left_v2.png',
            23784: 'img/ocean_rock_top_right_v2.png',
            23785: 'img/seashore_inner_southeast.png',
            23786: 'img/seashore_inner_southwest.png',
            23787: 'img/ocean_animation.png',
            23788: 'img/ocean_rock_bottom_left_v2.png',
            23789: 'img/ocean_rock_bottom_right_v2.png',
            23790: 'img/seashore_inner_northeast.png',
            23791: 'img/seashore_inner_northwest.png',
        };
        const imagePath = tileIdMap[data];
        this.water = new Sprite({
            position: this.position,
            image: imageStore.get(imagePath),
            frames: { max: 8, stopAtEnd: false },
            moving: true,
            visible: true,
            hold: 16,
        });
    }

    draw() {
        this.water.position = this.effectivePosition();
        if (!this.visible) {
            return;
        }
        this.water.draw();
    }
}
